<template>
    <div>
        <a class="btn btn-orange text-white float-right" @click="$bvModal.show($id('lavora_con_noi'))">{{$t('jobs.modal.title')}}</a>
        <b-modal size="lg" :title="subject" :id="$id('lavora_con_noi')" ref="lavora_con_noi"
                 @ok="sendRequest" @shown="onLoadModal">
            <div class="row">
                <div class="col-md-6">
                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('jobs.modal.name')}}</label>
                    <b-form-input v-model="form.name" v-validate="'required|min:2|max:16'" data-vv-name="name"
                                  :placeholder="$t('jobs.modal.name')"></b-form-input>
                    <span v-show="errors.has('name')" class="error">{{ errors.first('name') }}</span>
                </div>

                <div class="col-md-6">
                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('jobs.modal.surname')}}</label>
                    <b-form-input v-model="form.surname" v-validate="'required|min:2|max:16'" data-vv-name="surname"
                                  :placeholder="$t('jobs.modal.surname')"></b-form-input>
                    <span v-show="errors.has('surname')" class="error">{{ errors.first('surname') }}</span>
                </div>


                <div class="col-md-6">
                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('jobs.modal.birth_date')}}</label>
                    <b-input type="text"
                             v-model="form.birthdate"
                             data-vv-name="birthdate"
                             placeholder="gg-mm-aaaa"
                             autocomplete="nope"
                             v-validate="`required|date_format:dd-mm-yyyy|date_between:01-01-1900,${data_max}`"
                             data-vv-as="data di nascita"
                             key="data_nascita"
                             :formatter="data_format"
                             required></b-input>
                    <span v-show="errors.has('birthdate')" class="error">{{ errors.first('birthdate') }}</span>
                </div>

                <div class="col-md-6">
                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('jobs.modal.certificate')}}</label>
                    <b-form-select v-model="form.titolo_studio" :options="$t('jobs.titolo_di_studio')" required></b-form-select>
                </div>

                <div class="col-md-6">
                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('jobs.modal.occupation')}}</label>
                    <b-form-select v-model="form.professione" :options="$t('jobs.professione')" required></b-form-select>
                </div>

                <div class="col-md-6">
                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('jobs.modal.place_of_work')}}</label>
                    <b-form-select v-model="form.sede" :options="opt_sedi" required></b-form-select>
                </div>

                <div class="col-md-6">
                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('jobs.modal.phone_number')}}</label>
                    <b-form-input v-model="form.phone" v-validate="'required|min:6|max:16'" data-vv-name="telefono"
                                  :placeholder="$t('jobs.modal.phone_number')"></b-form-input>
                    <span v-show="errors.has('telefono')" class="error">{{ errors.first('telefono') }}</span>
                </div>

                <div class="col-md-6">
                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('jobs.modal.address_home')}}</label>
                    <b-form-textarea v-model="form.indirizzo" v-validate="'required|min:10'" data-vv-name="indirizzo"
                                     :placeholder="$t('jobs.modal.address_home')"></b-form-textarea>
                    <span v-show="errors.has('indirizzo')" class="error">{{ errors.first('indirizzo') }}</span>
                </div>

                <div class="col-md-6">
                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('jobs.modal.languages')}}</label>
                    <b-form-textarea v-model="form.lingue_straniere" v-validate="'required|min:10'"
                                     data-vv-name="lingue_straniere"
                                     :placeholder="$t('jobs.modal.languages')"></b-form-textarea>
                    <span v-show="errors.has('lingue_straniere')"
                          class="error">{{ errors.first('lingue_straniere') }}</span>
                </div>

                <div class="col-md-6">
                    <label class="text-uppercase small text-dark pl-2 mt-3">{{$t('jobs.modal.time_availability')}}</label>
                    <b-form-textarea v-model="form.orario_reperibilita" v-validate="'required|min:5'"
                                     data-vv-name="orario_reperibilita"
                                     :placeholder="$t('jobs.modal.time_availability')"></b-form-textarea>
                    <span v-show="errors.has('orario_reperibilita')" class="error">{{ errors.first('orario_reperibilita') }}</span>
                </div>

                <div class="col-md-12 mt-3">

                    <label class="text-uppercase small text-dark pl-2">{{$t('jobs.modal.email_address')}}</label>
                    <b-form-input class="mb-2" v-model="form.email" v-validate="'required|email'" data-vv-name="email"
                                  :placeholder="$t('jobs.modal.email_address')"></b-form-input>
                    <span v-show="errors.has('email')" class="error">{{ errors.first('email') }}</span>

                    <div class="mt-4">
                        <b-form-checkbox v-model="form.check_privacy" v-validate="'required'" data-vv-name="check_privacy">{{$t('jobs.fields.check_privacy')}}</b-form-checkbox>
                        <div v-show="errors.has('check_privacy')" class="error">{{ errors.first('check_privacy') }}</div>
                    </div>
                    <vue-recaptcha :sitekey="site_key" :loadRecaptchaScript="true" @verify="onCaptchaVerified"
                                   @expired="onCaptchaExpired" size="invisible" ref="recaptcha"></vue-recaptcha>
                    <span v-show="errors.has('message')" class="error">{{ errors.first('message') }}</span>
                </div>
            </div>

        </b-modal>

    </div>
</template>

<script>
    import VueRecaptcha from 'vue-recaptcha'

    export default {
        name: 'LavoraConNoi',
        props: [
            'subject'
        ],
        components: {VueRecaptcha},
        data() {
            return {
                data_max: '',
                form: {
                    check_privacy: false,
                    name: '',
                    surname: '',
                    email: '',
                    subject: '',
                    message: '',
                    fullname: '',
                    token: '',
                    phone: '',
                    topic: 3,
                    birthdate: '',
                    titolo_studio: '',
                    professione: '',
                    indirizzo: '',
                    lingue_straniere: '',
                    orario_reperibilita: '',
                    sede: ''
                }, sending: false,
                opt_sedi: []
            }
        },
        computed: {
            site_key() {
                return process.env.VUE_APP_PUBLIC_RECACPHA
            }
        },
        mounted() {
            this.form.subject = this.subject
            this.data_max = this.$moment().format('DD-MM-YYYY')
        },
        methods: {
            async onLoadModal() {
                let data = await this.get('table/tdspop')
                this.opt_sedi = []
                this.opt_sedi.push({value: '',text: this.$t('jobs.seleziona_sede')})
                for (let i = 0; i < data.GenericTables.length; i++)
                {
                    let sede = data.GenericTables[i]
                    this.opt_sedi.push({value: sede.Description,text: sede.Description})
                }
            },
            sendRequest(evt) {
                evt.preventDefault()
                if (!this.form.check_privacy) {
                    alert(this.$t('jobs.alert.check_privacy'))
                    return false
                }
                this.$store.commit('loading', true)
                if (this.form.token === '') {
                    this.sending = true
                    this.$refs.recaptcha.execute()
                    return
                }
                this.sendWithToken()
            }, onCaptchaVerified(ret) {
                this.form.token = ret
                this.$refs.recaptcha.reset()
                if (this.sending)
                    this.sendWithToken()
            }, onCaptchaExpired() {
                this.form.token = ''
            }, async sendWithToken() {
                this.sending = false
                this.form.fullname = this.form.name + ' ' + this.form.surname
                this.form.message = `
                        Data di nascita: ${this.form.birthdate}
                        Titolo di studio: ${this.form.titolo_studio}
                        Professione: ${this.form.professione}
                        Indirizzo di residenza: ${this.form.indirizzo}
                        Lingue straniere conosciute: ${this.form.lingue_straniere}
                        Orario di reperibilità: ${this.form.orario_reperibilita}
                        Sede in cui operare: ${this.form.sede}
                        Numero di telefono: ${this.form.phone}

                        Autorizzo TDS al trattamento dei miei dati per i soli fini inereti alla ricerca di personale

                        Invierò il mio curriculumo via e-mail a job@tds.sport specificando nell'oggetto il mio nominativo.
                `
                let data = await this.$http.post(this.$store.getters.tds_api + '/ticket/', this.form)
                this.form.token = ''
                if (data.status === 201) {
                    this.$notify({type: 'alert-success', text: this.$t('richiesta_contatto.alert.sent')})
                    this.$refs.lavora_con_noi.hide()
                    this.form.name = ''
                    this.form.surname = ''
                    this.form.email = ''
                    this.form.subject = ''
                    this.form.message = ''
                    this.form.fullname = ''
                    this.form.phone = ''
                    this.form.lingue_straniere = ''
                    this.form.orario_reperibilita = ''
                    this.form.sede = ''
                    this.form.titolo_studio = ''
                    this.form.professione = ''
                    this.form.birthdate = ''
                    this.form.check_privacy = false
                } else {
                    this.$notify({type: 'alert-danger', text: this.$t('richiesta_contatto.alert.error')})
                }
                this.$store.commit('loading', false)

            }, get: async function (params, loading) {
                try {
                    if (typeof loading === 'undefined') loading = false

                    if (loading) this.$store.commit('loading', true)

                    let result = await this.$http.get(this.$store.getters.url + params)
                    if (loading) this.$store.commit('loading', false)
                    return Promise.resolve(result.data)
                } catch (error) {
                    this.$notify({type: 'alert-info', text: this.$t('errors.loading')})
                    return Promise.resolve(false)
                }
            }, data_format(value) {
                if (value === null) return ''

                value = this._applyAt(value, 2, '-')
                value = this._applyAt(value, 5, '-')
                return value
            }, _applyAt(value, pos, divider) {
                let first = ''
                let last = ''

                if (value.length > pos) {
                    if (value[pos] !== divider) {
                        if (this.isNumeric(value[pos])) {
                            first = value.substr(0, pos)
                            last = value.substr(pos)
                            value = first + divider + last
                        } else {
                            first = value.substr(0, pos)
                            last = value.substr(pos + 1)
                            value = first + divider + last
                        }
                    }
                }
                return value
            }, isNumeric(s) {
                return !isNaN(s - parseFloat(s))
            }
        }
    }
</script>

<style scoped>

</style>
